import { useCallback, useEffect, useState } from "react";
import {
  BookingCalendar,
  generateDates,
  initialValue,
} from "../context/BookingCalendarContext";
import { getGymBookings } from "../service/booking-api";
import { Booking } from "../interface/Booking";
import { useSearchParams } from "react-router-dom";

export const useBookingCalendar = (
  gymId: string,
): {
  bookingCalendarData: BookingCalendar;
} => {
  const [params] = useSearchParams();
  const [bookings, setBookings] = useState<Booking[]>([]);
  const [currentDate, setCurrentDate] = useState<string>(
    new Date().toISOString(),
  );
  const [canFetchMore, setCanFetchMore] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);

  const fetchNextPage = useCallback(() => {
    setPage((prev) => prev + 1);
  }, [setPage]);

  useEffect(() => {
    setPage(1);
  }, [gymId, currentDate]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { data, canFetchMore: hasMore } = await getGymBookings({
      gymId,
      date: currentDate,
      page,
      limit: 250, // before BAC-6725 is fixed
    });
    setBookings((prev) => (page > 1 ? [...prev, ...data] : data));
    setCanFetchMore(hasMore);
    setLoading(false);
  }, [gymId, currentDate, page]);

  useEffect(() => {
    fetchData();
  }, [gymId, currentDate, fetchData]);

  return {
    bookingCalendarData: {
      bookings,
      currentDate,
      dates: generateDates(),
      setCurrentDate,
      fetchNextPage,
      canFetchMore,
      isLoading,
      redirectUrl: params.get("redirectUrl") || initialValue.redirectUrl,
    },
  };
};
